import axios from 'axios';
import { BASE_URL } from './helpers';

// The idea library: every run's input captured silently at run start, rated
// through the clip (that is where judgment happens), fed back into future
// discussions as worked examples. Naming note: this is deliberately NOT under
// the existing "ideas" modules — those belong to the unrelated idea generator.

export interface IdeaSummary {
  id: string;
  user_id: string;
  seed: string;
  refined?: string | null;
  template_id: string;
  template_name: string;
  params: Record<string, unknown>;
  run_id: string;
  created_at: string;
  /** Joined from the clip rating(s); null until a clip is rated. */
  score?: number | null;
  note?: string | null;
}

export interface ClipRating {
  id: string;
  user_id: string;
  clip_id: string;
  idea_id?: string;
  score: number;
  note: string;
  created_at: string;
  updated_at: string;
}

export const listIdeas = (options?: { templateId?: string; minScore?: number; limit?: number }) =>
  axios
    .get<IdeaSummary[]>(`${BASE_URL}/idea-library`, {
      params: {
        template_id: options?.templateId || undefined,
        min_score: options?.minScore || undefined,
        limit: options?.limit || undefined,
      },
    })
    .then((res) => res.data || []);

export const getIdea = (ideaId: string) =>
  axios.get<IdeaSummary>(`${BASE_URL}/idea-library/${ideaId}`).then((res) => res.data);

/** Prunes one idea from the library for good. 204, no body. */
export const deleteIdea = (ideaId: string): Promise<void> =>
  axios.delete(`${BASE_URL}/idea-library/${ideaId}`).then(() => undefined);

/** null = the clip has no rating yet. */
export const getClipRating = (clipId: string) =>
  axios.get<ClipRating | null>(`${BASE_URL}/clips/${clipId}/rating`).then((res) => res.data ?? null);

export const rateClip = (clipId: string, rating: { score: number; note: string }) =>
  axios
    .post<{ rating: ClipRating; idea_id?: string }>(`${BASE_URL}/clips/${clipId}/rating`, rating)
    .then((res) => res.data);

/** Drafts the one-line "why" from the clip's idea; fills the input, never saves. */
export const draftRatingReason = (clipId: string, score: number) =>
  axios
    .post<{ note: string }>(`${BASE_URL}/clips/${clipId}/rating/draft-reason`, { score })
    .then((res) => res.data.note);
